import EmplacementsTab from "@features/stock/components/EmplacementsTab";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { ClipboardCheck } from "lucide-react";

export const Route = createFileRoute("/_app/stock/emplacements")({
  staticData: {
    title: "Emplacements",
    icon: ClipboardCheck,
    tab_icon: ClipboardCheck,
    permission: PERMISSIONS.STOCK.EMPLACEMENTS.VIEW,
    module: "stock",
    section: "Stock",
    order: 47.5,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
  },
  loader: requirePermission(PERMISSIONS.STOCK.EMPLACEMENTS.VIEW),
  component: EmplacementsTab,
});
